var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/TitledOverlay/TitledOverlay.tsx
import React6, {
  cloneElement,
  isValidElement,
  useEffect as useEffect4,
  useRef as useRef2,
  useState as useState3
} from "react";
import { useId } from "@react-aria/utils";
import {
  useElementDimensions as useElementDimensions2,
  useResizeObserver
} from "@volvo-cars/react-layout-utils";
import { useElementHasScrolled } from "@volvo-cars/react-scroll-utils";
import FocusTrap from "focus-trap-react";
import { Block, Col, Grid, Row, useTheme } from "vcc-ui";

// src/Appear/Appear.tsx
import React3, { createContext as createContext2, useContext as useContext2 } from "react";
import { Transition } from "react-transition-group";
import { Flex } from "vcc-ui";

// src/hooks/useResetScroll.ts
import { useEffect } from "react";
var useResetScroll = ({
  isOpen,
  scrollingElRef,
  resetScroll = true
}) => {
  useEffect(() => {
    var _a, _b;
    if (resetScroll && isOpen) {
      (_b = (_a = scrollingElRef.current) == null ? void 0 : _a.scrollTo) == null ? void 0 : _b.call(_a, 0, 0);
    }
  }, [isOpen, resetScroll, scrollingElRef]);
  return scrollingElRef;
};
var useResetScroll_default = useResetScroll;

// src/OverlayStacker/OverlayStacker.tsx
import React2, {
  createContext,
  useContext,
  useEffect as useEffect2,
  useRef,
  useState
} from "react";
var OverlayStackerContext = createContext({
  overlayStackedCount: null
});
var OverlayStacker = ({ children }) => {
  const overlayStackedCount = useRef(0);
  return /* @__PURE__ */ React2.createElement(OverlayStackerContext.Provider, {
    value: {
      overlayStackedCount
    }
  }, children);
};
var getStackedZIndex = (zIndex, overlayStackedCount) => {
  if (typeof zIndex === "number") {
    return zIndex + overlayStackedCount.current;
  }
  return `calc(${zIndex} + ${1 + overlayStackedCount.current})`;
};
var useOverlayStacker = (zIndex, isOpen) => {
  const [stackedZIndex, setStackedZIndex] = useState(zIndex);
  const { overlayStackedCount } = useContext(OverlayStackerContext);
  useEffect2(() => {
    if (!overlayStackedCount) {
      return;
    }
    if (isOpen === true) {
      setStackedZIndex(getStackedZIndex(zIndex, overlayStackedCount));
      overlayStackedCount.current++;
    }
    if (isOpen === false) {
      setStackedZIndex(zIndex);
    }
    if (typeof isOpen !== "boolean") {
      setStackedZIndex(getStackedZIndex(zIndex, overlayStackedCount));
      overlayStackedCount.current++;
      return () => {
        setStackedZIndex(zIndex);
      };
    }
  }, [isOpen, overlayStackedCount, zIndex]);
  return {
    stackedZIndex
  };
};

// src/Appear/Appear.tsx
var TRANSITION_TIME = 300;
var AppearContext = createContext2({
  isOpen: true,
  resetScroll: true
});
var Appear = ({
  children,
  isOpen = false,
  resetScroll = true,
  zIndex = "calc(var(--sitenav-z-index-max, 1010) + 1)"
}) => {
  const { stackedZIndex } = useOverlayStacker(zIndex, isOpen);
  return /* @__PURE__ */ React3.createElement(Transition, {
    in: isOpen,
    timeout: TRANSITION_TIME,
    appear: true
  }, (state) => {
    return /* @__PURE__ */ React3.createElement(Flex, {
      "aria-hidden": !isOpen,
      extend: containerStyle({
        isOpen,
        state,
        transitionTime: TRANSITION_TIME,
        zIndex: stackedZIndex
      })
    }, /* @__PURE__ */ React3.createElement(AppearContext.Provider, {
      value: {
        isOpen: state === "entered",
        resetScroll
      }
    }, children));
  });
};
var containerStyle = ({
  isOpen,
  state,
  transitionTime,
  zIndex
}) => () => ({
  overflowY: "hidden",
  opacity: state === "exiting" || state === "exited" ? 0 : 1,
  visibility: state === "exited" && !isOpen ? "hidden" : "visible",
  transition: `opacity ${transitionTime}ms ease-out`,
  position: "fixed",
  top: state === "exiting" || state === "exited" ? "calc(200vh + 100%)" : 0,
  right: 0,
  bottom: 0,
  left: 0,
  zIndex
});
var useAppear = ({
  scrollingElRef
}) => {
  const { isOpen, resetScroll } = useContext2(AppearContext);
  useResetScroll_default({
    isOpen,
    resetScroll,
    scrollingElRef
  });
  return { isOpen };
};

// src/hooks/useOverlay.ts
import { useEffect as useEffect3, useState as useState2 } from "react";
import { useScrollLock } from "@volvo-cars/react-scroll-utils";
import { useKeyPress } from "@volvo-cars/react-utils";
import { useTracker } from "@volvo-cars/tracking";
var useOverlay = ({
  close,
  eventLabel
}) => {
  const [elementsMounted, setElementsMounted] = useState2(false);
  const tracker = useTracker(null, {}, { ignoreIfEmptyContext: true });
  const closeAndTrackEvent = () => {
    tracker.interaction({
      eventAction: "click",
      eventLabel
    });
    close();
  };
  useEffect3(() => {
    setElementsMounted(true);
  }, []);
  useKeyPress("Escape", closeAndTrackEvent);
  useScrollLock(elementsMounted);
  return {
    closeAndTrackEvent,
    elementsMounted
  };
};
var useOverlay_default = useOverlay;

// src/PreventClickPassThrough/index.tsx
import React4 from "react";
var PreventClickPassThrough = ({ children }) => /* @__PURE__ */ React4.createElement("div", {
  onClick: (e) => e.stopPropagation()
}, children);

// src/shared/style.ts
var contentWrap = {
  flexDirection: "row",
  justifyContent: "center",
  width: "100%",
  marginLeft: "auto",
  marginRight: "auto"
};
var forceFillAvailableSpace = {
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

// src/TitleBar/TitleBar.tsx
import React5, { forwardRef } from "react";
import { useElementDimensions } from "@volvo-cars/react-layout-utils";
import { useTranslate } from "@volvo-cars/react-shared-translations";
import { Flex as Flex2, IconButton, Text } from "vcc-ui";

// src/TitleBar/TitleBar.styles.tsx
var iconAside = {
  minWidth: "24px",
  flexGrow: 0,
  justifyContent: "center"
};
var title = {
  flexGrow: 1,
  justifyContent: "center"
};
var titleBarStyle = (minimised, fixed, dimensions) => ({ theme: { color, baselineGrid } }) => ({
  backgroundColor: color.background.primary,
  boxSizing: "border-box",
  width: "100%",
  position: fixed ? "sticky" : "static",
  top: fixed ? "0" : "",
  height: dimensions.width <= 480 ? minimised ? "64px" : "96px" : minimised ? "80px" : "128px",
  paddingLeft: 3 * baselineGrid,
  paddingRight: 3 * baselineGrid,
  borderBottom: `1px solid ${color.ornament.divider}`,
  textAlign: "center",
  transition: "height 300ms ease-in-out 0s",
  justifyContent: "center"
});
var titleTextTransition = {
  margin: 0,
  transition: "all 300ms ease-in-out",
  fontWeight: 500
};

// src/TitleBar/TitleBar.tsx
var TitleBar = forwardRef(({
  children,
  closeAction,
  fixed = false,
  id,
  showBackArrow = false,
  backArrowAction,
  minimised = true
}, ref) => {
  const [containerRef, dimensions] = useElementDimensions();
  const closeLabel = useTranslate("react-overlay.close");
  const backLabel = useTranslate("react-overlay.back");
  return /* @__PURE__ */ React5.createElement(Flex2, {
    ref,
    id,
    extend: titleBarStyle(minimised, fixed, dimensions)
  }, /* @__PURE__ */ React5.createElement(Flex2, {
    ref: containerRef,
    extend: contentWrap
  }, /* @__PURE__ */ React5.createElement(Flex2, {
    extend: iconAside
  }, showBackArrow && backArrowAction && /* @__PURE__ */ React5.createElement(IconButton, {
    onClick: backArrowAction,
    "aria-label": backLabel,
    iconName: "navigation-chevronback"
  })), /* @__PURE__ */ React5.createElement(Flex2, {
    extend: title
  }, /* @__PURE__ */ React5.createElement(Text, {
    as: "h2",
    subStyle: "emphasis",
    variant: dimensions.width <= 480 ? minimised ? "columbus" : "hillary" : minimised ? "hillary" : "ootah",
    extend: titleTextTransition
  }, children)), /* @__PURE__ */ React5.createElement(Flex2, {
    extend: iconAside
  }, /* @__PURE__ */ React5.createElement(IconButton, {
    iconName: "navigation-close",
    "aria-label": closeLabel,
    onClick: closeAction
  }))));
});
TitleBar.displayName = "TitleBar";

// src/TitledOverlay/TitledOverlay.tsx
var DEFAULT_MARGIN = 44;
var MOBILE_MARGIN = 16;
var TitledOverlay = ({
  children,
  close,
  colSpan,
  elementId,
  minimisableTitle,
  navPreviousPane,
  title: title2,
  zIndex = "calc(var(--sitenav-z-index-max, 1010) + 1)"
}) => {
  const [scrollingElRef, hasScrolled] = useElementHasScrolled({});
  const [containerHeight, setContainerHeight] = useState3(0);
  const id = useId(elementId);
  const { ref: titleRef, height: titleBarHeight } = useResizeObserver();
  const [containerRef, containerDimensions] = useElementDimensions2();
  const { elementsMounted, closeAndTrackEvent } = useOverlay_default({
    close,
    eventLabel: "overlay-close"
  });
  const { isOpen } = useAppear({
    scrollingElRef
  });
  const { stackedZIndex } = useOverlayStacker(zIndex);
  const IS_CONSTRAINED_MODAL = colSpan;
  const computedMargin = useRef2(DEFAULT_MARGIN);
  useEffect4(() => {
    titleBarHeight && setContainerHeight(() => {
      const height = window.innerHeight - titleBarHeight;
      computedMargin.current = containerDimensions.width >= 480 ? DEFAULT_MARGIN : MOBILE_MARGIN;
      if (IS_CONSTRAINED_MODAL) {
        return height - computedMargin.current * 2;
      }
      return height;
    });
  }, [hasScrolled, titleBarHeight, IS_CONSTRAINED_MODAL, containerDimensions]);
  const { color } = useTheme();
  const childWithParentDimensions = isValidElement(children) && cloneElement(children, { parentDimensions: containerDimensions });
  return /* @__PURE__ */ React6.createElement(FocusTrap, {
    active: !!(isOpen && elementsMounted)
  }, /* @__PURE__ */ React6.createElement(Block, {
    ref: containerRef,
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": id,
    extend: __spreadProps(__spreadValues({
      backgroundColor: colSpan ? "rgb(20 20 20 / 33%)" : color.background.primary,
      overflowY: "hidden"
    }, forceFillAvailableSpace), {
      zIndex: stackedZIndex
    }),
    onClick: colSpan ? closeAndTrackEvent : void 0
  }, /* @__PURE__ */ React6.createElement(FullScreenOrConstrained, {
    colSpan,
    responsiveMargin: computedMargin.current
  }, /* @__PURE__ */ React6.createElement(PreventClickPassThrough, null, /* @__PURE__ */ React6.createElement(TitleBar, {
    ref: titleRef,
    id,
    closeAction: closeAndTrackEvent,
    fixed: true,
    minimised: minimisableTitle ? hasScrolled : true,
    showBackArrow: !!navPreviousPane,
    backArrowAction: navPreviousPane
  }, title2), /* @__PURE__ */ React6.createElement("div", {
    style: {
      height: containerHeight,
      overflowY: "scroll",
      backgroundColor: color.background.primary
    },
    ref: scrollingElRef
  }, /* @__PURE__ */ React6.createElement(Block, {
    extend: contentWrap
  }, childWithParentDimensions))))));
};
var FullScreenOrConstrained = ({
  colSpan,
  children,
  responsiveMargin
}) => !colSpan ? /* @__PURE__ */ React6.createElement(React6.Fragment, null, children) : /* @__PURE__ */ React6.createElement(GridConstraint, {
  colSpan,
  responsiveMargin
}, children);
var GridConstraint = ({
  children,
  colSpan,
  responsiveMargin
}) => {
  return /* @__PURE__ */ React6.createElement(Grid, null, /* @__PURE__ */ React6.createElement(Row, {
    align: "center"
  }, /* @__PURE__ */ React6.createElement(Col, {
    size: colSpan
  }, /* @__PURE__ */ React6.createElement(Block, {
    extend: {
      marginTop: responsiveMargin,
      marginBottom: responsiveMargin,
      height: "100vh"
    }
  }, children))));
};

// src/ContentBlock/ContentBlock.tsx
import React7 from "react";
import { Block as Block2 } from "vcc-ui";
var containerPaddings = (baselineGrid) => ({
  small: {
    paddingTop: 5 * baselineGrid,
    paddingRight: 3 * baselineGrid,
    paddingBottom: 5 * baselineGrid,
    paddingLeft: 3 * baselineGrid
  },
  fromM: {
    paddingTop: 8 * baselineGrid,
    paddingRight: 3 * baselineGrid,
    paddingBottom: 8 * baselineGrid,
    paddingLeft: 3 * baselineGrid
  }
});
var ContentBlock = ({
  children,
  parentDimensions
}) => {
  const widthRelativePadding = (baselineGrid) => parentDimensions && parentDimensions.width >= 480 ? containerPaddings(baselineGrid)["fromM"] : containerPaddings(baselineGrid)["small"];
  return /* @__PURE__ */ React7.createElement(Block2, {
    extend: ({ theme: { color, baselineGrid } }) => __spreadValues({
      backgroundColor: color.background.primary
    }, widthRelativePadding(baselineGrid))
  }, children);
};

// src/Overlay/Overlay.tsx
import React9, { useRef as useRef3 } from "react";
import FocusTrap2 from "focus-trap-react";
import { Block as Block3, Col as Col2, Grid as Grid2, Row as Row2, useTheme as useTheme2 } from "vcc-ui";

// src/CloseBar/CloseBar.tsx
import React8 from "react";
import { useTranslate as useTranslate2 } from "@volvo-cars/react-shared-translations";
import { Flex as Flex3, IconButton as IconButton2 } from "vcc-ui";

// src/CloseBar/CloseBar.styles.tsx
var CLOSE_BAR_HEIGHT = 96;
var closeBarStyle = ({
  theme: { color, baselineGrid }
}) => ({
  backgroundColor: color.background.primary,
  boxSizing: "border-box",
  width: "100%",
  position: "sticky",
  top: 0,
  paddingLeft: 3 * baselineGrid,
  paddingRight: 3 * baselineGrid,
  alignItems: "flex-end",
  justifyContent: "center",
  height: `${CLOSE_BAR_HEIGHT}px`
});

// src/CloseBar/CloseBar.tsx
var CloseBar = ({ closeAction }) => {
  const closeLabel = useTranslate2("react-overlay.close");
  return /* @__PURE__ */ React8.createElement(Flex3, {
    extend: closeBarStyle
  }, /* @__PURE__ */ React8.createElement(IconButton2, {
    iconName: "navigation-close",
    "aria-label": closeLabel,
    onClick: closeAction
  }));
};

// src/Overlay/Overlay.tsx
var Overlay = (_a) => {
  var _b = _a, {
    children,
    close,
    colSpan,
    zIndex = "calc(var(--sitenav-z-index-max, 1010) + 1)"
  } = _b, rest = __objRest(_b, [
    "children",
    "close",
    "colSpan",
    "zIndex"
  ]);
  const scrollingElRef = useRef3(null);
  const { elementsMounted, closeAndTrackEvent } = useOverlay_default({
    close,
    eventLabel: "overlay-close"
  });
  const { isOpen } = useAppear({
    scrollingElRef
  });
  const { color } = useTheme2();
  const { stackedZIndex } = useOverlayStacker(zIndex);
  return /* @__PURE__ */ React9.createElement(FocusTrap2, {
    active: !!(isOpen && elementsMounted)
  }, /* @__PURE__ */ React9.createElement(Block3, __spreadProps(__spreadValues({
    role: "dialog",
    "aria-modal": "true"
  }, rest), {
    extend: __spreadProps(__spreadValues({
      backgroundColor: colSpan ? "rgb(20 20 20 / 33%)" : color.background.primary,
      overflowY: "hidden"
    }, forceFillAvailableSpace), {
      zIndex: stackedZIndex
    }),
    onClick: colSpan ? closeAndTrackEvent : void 0
  }), /* @__PURE__ */ React9.createElement(FullScreenOrConstrained2, {
    colSpan
  }, /* @__PURE__ */ React9.createElement(PreventClickPassThrough, null, /* @__PURE__ */ React9.createElement(CloseBar, {
    closeAction: closeAndTrackEvent
  }), /* @__PURE__ */ React9.createElement("div", {
    ref: scrollingElRef,
    style: {
      overflowY: "scroll",
      height: "100vh",
      maxHeight: "calc(100vh - 176px)",
      backgroundColor: color.background.primary
    }
  }, /* @__PURE__ */ React9.createElement(Block3, {
    extend: contentWrap
  }, children))))));
};
var GridConstraint2 = ({
  children,
  colSpan
}) => {
  return /* @__PURE__ */ React9.createElement(Grid2, null, /* @__PURE__ */ React9.createElement(Row2, {
    align: "center"
  }, /* @__PURE__ */ React9.createElement(Col2, {
    size: colSpan
  }, /* @__PURE__ */ React9.createElement(Block3, {
    extend: {
      marginTop: "44px"
    }
  }, children))));
};
var FullScreenOrConstrained2 = ({
  colSpan,
  children
}) => !colSpan ? /* @__PURE__ */ React9.createElement(React9.Fragment, null, children) : /* @__PURE__ */ React9.createElement(GridConstraint2, {
  colSpan
}, children);
export {
  Appear,
  ContentBlock,
  Overlay,
  OverlayStacker,
  TitledOverlay
};
